import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
const norm = (u) => (u && u.role === "supervisor" ? { ...u, role: "admin", supervisor: true } : u && u.role === "office" ? { ...u, role: "admin", office: true } : u);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // OAuth callback: AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) return;
    if (!localStorage.getItem("fleet_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(norm(r.data))).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fleet_token", data.token);
    setUser(norm(data.user));
    return norm(data.user);
  };

  const loginWithGoogle = async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    localStorage.setItem("fleet_token", data.token);
    setUser(norm(data.user));
    return norm(data.user);
  };

  const logout = () => {
    localStorage.removeItem("fleet_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, loginWithGoogle, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
